<template>
    <section class="settings-section">
        <div class="container container--mw-lg">
            <h2 class="settings-section__heading">Account Settings</h2>

            <div class="row justify-content-center m-0">
                <div class="col-12 col-lg-6 settings-section__column">
                    <ToolBlock
                        :svg="'settings'"
                        :text="'Update your<br> account details'"
                        :block-link="'/my-account/setting'"
                    />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import ToolBlock from "@/views/MyAccount/ToolBlock";

    export default {
        name: 'AccountSettings',
        components: {
            ToolBlock
        }
    }
</script>